<template lang="html">
<!-- Start Nurse Item -->
<div class="col-md-4 col-sm-4 col-xs-6 col-lg-3">
  <div class="profile-widget">
    <div class="nurse-img">
      <router-link class="avatar" :to="'/profile/' + nurse.id">
        <img :alt="nurse.name.slice(0,1)" :src="nurse.photo || '/images/Team/nurse_1.jpg'" />
      </router-link>
    </div>
    <div class="dropdown profile-action">
      <a href="#!" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
      <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(23px, 27px, 0px);">
        <!-- <router-link class="dropdown-item" :to="'/edit-nurse/'+ nurse.id"><i class="fa fa-pencil m-r-5"></i> Edit</router-link> -->
        <a class="dropdown-item" href="#!" @click="delNurse()"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
        <a v-if="$route.path.includes('/activenurses')" class="dropdown-item" href="#!" @click="giveTheOrder()"> Give The order </a>
      </div>
    </div>
    <h4 class="nurse-name text-ellipsis"><router-link :to="'/profile/' + nurse.id">{{nurse.name}}</router-link></h4>
    <div class="nurse-prof">{{nurse.email}}</div>
    <div class="user-phone"><i class="fa fa-phone"></i> {{nurse.mobile}}</div>
  </div>
</div>
<!-- End Nurse Item -->
</template>

<script>
export default {
  props: ['nurse'],
  computed: {
    api() {
      return this.$store.state.api;
    }
  },
  methods: {
    delNurse() {
      fetch(`${this.api}/admin/nurse/${this.nurse.id}`, {
          method: 'DELETE',
          headers: {
            "Authorization": localStorage.getItem('care_auth_token') || null
          }
        })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if(data.success){
            this.$emit('deleteNurse', this.nurse.id)
          }
        });
    },
    giveTheOrder(){
      fetch(`${this.api}/admin/order/update/${this.$route.params.orderId}?user_id=${this.nurse.id}&status=1`, {
          method: 'POST',
          headers: {
            "Authorization": localStorage.getItem('care_auth_token') || null
          }
        })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if(data.success){
            this.$emit('takeTheNurse', this.nurse.id)
          }
        });
    }
  }
}
</script>

<style lang="css" scoped>
</style>
